class ReactSubscribable {

    reactSubscribers = [];
    state = {}

    subscribeReact(callback) {
        this.reactSubscribers.push(callback);
        return () => {
            this.reactSubscribers = this.reactSubscribers.filter(subscriber => subscriber !== callback);
        }
    }

    getReactSnapshot() {
        return this.state;
    }

    notifyReactSubscribers() {
        this.reactSubscribers.forEach(callback => {
            callback(this.state);
        })
    }

    updateState(newState) {
        this.state = {
            ...this.state,
            ...newState
        }
        this.notifyReactSubscribers();
    }
}

export default ReactSubscribable;